import { url } from "inspector";
import { useTranslation } from "react-i18next";

import { ArrowRight } from "@/assets/icons/icons";
import { DeviceTile } from "@/components/Portal/Cockpit/Tiles/DeviceTile/DeviceTile";
import env from "@/utils/environmentHelpers";

export const PromoItemizedBillTile = () => {
  const { t } = useTranslation("portal");

  const getRedirectLink = () => {
    let baseUrl = "http://localhost:3000";

    // Test Server / "INT"
    if (env.isTest) {
      baseUrl = "https://digital-republic.ambient.digital";
    }

    // Prod Server / "Release"
    if (env.isProd) {
      baseUrl = "https://connect.digitalrepublic.ch";
    }

    return `${baseUrl}/portal/documents/itemized-bills#/portal/documents/itemized-bills
    `;
  };

  return (
    <a href={getRedirectLink()} target="_blank" rel="noreferrer">
      <DeviceTile dataTestid="promo-itemized-bill-tile">
        <div className="m-auto">
          <p className="text-left text-base leading-normal text-secondary-100">
            {t("layout.tiles.promoItemizedBill.heading")}
          </p>
          <h2 className="mt-6 text-primary-100">
            {t("layout.tiles.promoItemizedBill.text")}
          </h2>
        </div>
        <div className="button-wrapper">
          <button className="button">
            <span className="manage">
              {t("layout.tiles.promoItemizedBill.activateNow")}
            </span>
            <ArrowRight />
          </button>
        </div>
      </DeviceTile>
    </a>
  );
};
